import type { AxiosResponse } from "axios";

import { getRequest } from "../HttpRequestIND";

export interface IDistrictRequest {
  state: string;
  city: string;
}

export interface IGetServices extends IDistrictRequest {
  plan: string;
  district: string;
  occupationArea: string;
}

type TemplateParamValue = string | number | null | undefined;
type TemplateParams = Record<string, TemplateParamValue>;

type CredentialNetworkEnvName =
  | "VITE_REDE_CREDENCIADA_CIDADES"
  | "VITE_REDE_CREDENCIADA_ESTADOS"
  | "VITE_REDE_CREDENCIADA_BAIRROS"
  | "VITE_REDE_CREDENCIADA_RESULT"
  | "VITE_REDE_CREDENCIADA_AREA_ATUACOES";

export const getRequiredEnv = (name: CredentialNetworkEnvName): string => {
  const value = import.meta.env[name];

  if (!value) {
    throw new Error(`Variável de ambiente ${name} não configurada.`);
  }

  return value;
};

const toSafeParamValue = (value: TemplateParamValue): string => {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value);
};

const replaceTemplateParam = (
  template: string,
  key: string,
  value: TemplateParamValue
): string => {

  console.log(template, key, value)
  const placeholder = `{${key}}`;
  const encodedValue = encodeURIComponent(toSafeParamValue(value));

  return template.split(placeholder).join(encodedValue);
};

export const buildUrlFromTemplate = (
  template: string,
  params: TemplateParams = {}
): string => {
  return Object.entries(params).reduce((url, [key, value]) => {
    return replaceTemplateParam(url, key, value);
  }, template);
};

export const getCities = async <TResponse = unknown>(
  state: string
): Promise<AxiosResponse<TResponse>> => {
  const template = getRequiredEnv("VITE_REDE_CREDENCIADA_CIDADES");

  const url = buildUrlFromTemplate(template, {
    uf: state,
  });

  return getRequest<TResponse>(url);
};

export const getStates = async <
  TResponse = unknown
>(): Promise<AxiosResponse<TResponse>> => {
  const url = getRequiredEnv("VITE_REDE_CREDENCIADA_ESTADOS");

  return getRequest<TResponse>(url);
};

export const getDistricts = async <TResponse = unknown>({
  state,
  city,
}: IDistrictRequest): Promise<AxiosResponse<TResponse>> => {
  const template = getRequiredEnv("VITE_REDE_CREDENCIADA_BAIRROS");

  const url = buildUrlFromTemplate(template, {
    uf: state,
    cidade: city,
  });

  return getRequest<TResponse>(url);
};

export const getFinalData = async <TResponse = unknown>({
  plan,
  state,
  city,
  district,
  occupationArea,
}: IGetServices): Promise<AxiosResponse<TResponse>> => {
  const template = getRequiredEnv("VITE_REDE_CREDENCIADA_RESULT");

  const url = buildUrlFromTemplate(template, {
    planCode: plan,
    uf: state,
    city,
    district,
    occupationArea,
  });

  return getRequest<TResponse>(url);
};

export const getOccupationArea = async <TResponse = unknown>(
  state?: string
): Promise<AxiosResponse<TResponse>> => {
  const template = getRequiredEnv("VITE_REDE_CREDENCIADA_AREA_ATUACOES");

  const url = buildUrlFromTemplate(template, {
    uf: state,
  });

  return getRequest<TResponse>(url);
};